import { render, staticRenderFns } from "./SyncAudioPlayer.vue?vue&type=template&id=ef94222c&"
import script from "./SyncAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./SyncAudioPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports